import React, { useEffect, useState } from "react";
import { useGlobal } from "reactn";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import "./CustomerContactEmail.css";

const requestOptions = { "axios-retry": { retries: 0 } };

export function CustomerContactEmailForm({ account }) {
  const [email, setEmail] = useState("");
  const [savedEmail, setSavedEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [available, setAvailable] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const endpoint = `${process.env.REACT_APP_API}/partners/organization_profile/customer-contact-email`;

  useEffect(() => {
    let active = true;
    setLoading(true); setAvailable(false); setError(""); setSaved(false);
    axios.get(endpoint, requestOptions).then(response => {
      if (!active) return;
      if (!response.data.success) throw new Error(response.data.message);
      const data = response.data.data;
      setEmail(data.email); setSavedEmail(data.email);
      setAvailable(data.available);
      if (!data.available) setError("This setting will be available when the system update is complete.");
    }).catch(cause => {
      if (active) setError(cause.response?.data?.message || "Unable to load the customer contact email. Please refresh and try again.");
    }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [endpoint, account.id, account.user_id]);

  const save = async event => {
    event.preventDefault();
    if (saving || !available) return;
    setSaving(true); setSaved(false); setError("");
    try {
      const response = await axios.put(endpoint, { email: email.trim() }, requestOptions);
      if (!response.data.success) throw new Error(response.data.message);
      setEmail(response.data.data.email); setSavedEmail(response.data.data.email); setSaved(true);
    } catch (cause) {
      setError(cause.response?.data?.message || "Unable to save the customer contact email. Please try again.");
    } finally { setSaving(false); }
  };

  return <form className="customer-contact-email" onSubmit={save}>
      <div className="row">
        <div className="col-5">
          <h3>
            <label htmlFor="customer-contact-email">Customer contact email</label>{" "}
            <button type="button" className="customer-contact-email-info" aria-label="About customer contact email"
              data-tip data-for="customer-contact-email-help"
              onFocus={event => ReactTooltip.show(event.currentTarget)}
              onBlur={event => ReactTooltip.hide(event.currentTarget)}>i</button>
          </h3>
        </div>
        <div className="col-7 d-flex">
          <div className="w-100">
            <input id="customer-contact-email" type="email" maxLength={254} value={email}
              placeholder="e.g. info@yourorganization.com" autoComplete="email"
              aria-describedby="customer-contact-email-help" disabled={loading || saving || !available}
              onChange={event => { setEmail(event.target.value); setSaved(false); }} />
            {error && <p role="alert" className="customer-contact-email-error">{error}</p>}
            {saved && <p role="status">Customer contact email saved.</p>}
            <div className="buttons">
              <button type="submit" className="savebtn" disabled={loading || saving || !available || email.trim() === savedEmail}>
                {loading ? "Loading…" : saving ? "Saving…" : "Save contact email"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip id="customer-contact-email-help" className="customer-contact-email-tooltip" place="top" effect="solid" type="info">
        Customers will see this address in emails and can reply to it. Leave blank to use your main account email.
      </ReactTooltip>
    </form>;
}

export default function CustomerContactEmail() {
  const [account] = useGlobal("dsUser");
  if (account?.accountType !== "Partner" || account.sub_user !== false) return null;
  return <CustomerContactEmailForm account={account} />;
}
